import { render, staticRenderFns } from "./_characterId.vue?vue&type=template&id=e009cf42&scoped=true&"
import script from "./_characterId.vue?vue&type=script&lang=js&"
export * from "./_characterId.vue?vue&type=script&lang=js&"
import style0 from "./_characterId.vue?vue&type=style&index=0&id=e009cf42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e009cf42",
  null
  
)

export default component.exports